import { EQUIPMENT_TYPES } from "constants/insurance";
import { calculateEndDate } from "utils/insurance-validators";

/**
 * Transform form values from Ant Design Form into the API request body format.
 * Matches the backend POST /api/v1/insurance/application contract.
 *
 * @param {object} values - Ant Design form values
 * @returns {object} API request body
 */
export function transformFormValues(values) {
  // Build equipment array from the nested structure
  const equipment = [];
  if (values.equipment) {
    EQUIPMENT_TYPES.forEach((type) => {
      const entries = values.equipment[type.value];
      if (entries && Array.isArray(entries)) {
        entries.forEach((entry) => {
          if (entry && (entry.pieceCount || entry.identification || entry.brand)) {
            equipment.push({
              type: type.value,
              pieceCount: entry.pieceCount || null,
              identification: entry.identification || null,
              brand: entry.brand || null,
            });
          }
        });
      }
    });
  }

  // Calculate end date from start date
  const startDate = values.insuranceStartDate;
  const endDate = calculateEndDate(startDate);

  return {
    insured: {
      fullName: values.insuredFullName,
      address: {
        street: values.insuredStreet,
        city: values.insuredCity,
        province: values.insuredProvince,
        postalCode: values.insuredPostalCode,
      },
      telephone: values.insuredTelephone || null,
      mobile: values.insuredMobile || null,
      email: values.insuredEmail || null,
      occupation: values.insuredOccupation || null,
    },
    beneficiary: {
      fullName: values.beneficiaryFullName,
      address: values.beneficiaryAddress,
      relationship: values.beneficiaryRelationship,
      relationshipOther: values.beneficiaryRelationshipOther || null,
    },
    golfHistory: {
      clubMembership: values.clubMembership || null,
      isProfessional: values.isProfessional || false,
      hasExistingInsurance: values.hasExistingInsurance || false,
      existingInsuranceCompany: values.existingInsuranceCompany || null,
      existingInsuranceSumInsured: values.existingInsuranceSumInsured || null,
      hasPreviousRefusal: values.hasPreviousRefusal || false,
      previousRefusalCompany: values.previousRefusalCompany || null,
    },
    equipment,
    coverageAcknowledged: values.coverageAcknowledged || false,
    insurancePeriod: {
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
    },
  };
}

/**
 * Determine if an axios error is a timeout error.
 *
 * @param {object} error - Axios error object
 * @returns {boolean} true if the error is a timeout error
 */
export function isTimeoutError(error) {
  return (
    error.code === "ECONNABORTED" ||
    (error.message != null && error.message.toLowerCase().includes("timeout"))
  ) || false;
}
